// test2173
(2173 && 0);
